import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-ads-customer',
  templateUrl: './help-google-ads-customer.component.html',
  styleUrls: ['./help-google-ads-customer.component.scss']
})
export class HelpGoogleAdsCustomerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
